<template>
    <el-upload
        class="upload-demo"
        :action="upload_url"
        :on-success="upload_success"
        :on-error="upload_error"
        :before-upload="before_upload"
        :data="upload_data"
        :show-file-list="false"
        :disabled="disabled"
        :on-progress="fileProgress"
        :accept="accept">
            <el-button :disabled="disabled" size="small" :type="disabled ? 'info' : 'primary'">{{ title }}{{ show_list && show_progress && progress != 100 ? `&emsp;&emsp;` + progress.toFixed(2) + '%' : '' }}</el-button>
    </el-upload>
</template>
<script>
export default {
    props: {
        fileList: {
            type: Array,
            default: []
        },
        dir: {
            type: String,
            default: 'admin'
        },
        title: {
            type: String,
            default: '上传图片'
        },
        disabled: {                         // 是否禁用
            type: Boolean,
            default: false
        },
        accept: {                           // 上传文件类型
            type: String,
            default: ''
        },
        max_size: {                         // 上传文件大小
            type: Number,
            default: 1024
        },
        show_list: {                        // 是否显示列表
            type: Boolean,
            default: false
        }
    },
    watch: {
        fileList: {
            handler(val, oldVal) {
                // 如果val有，oldVal没有，说明是默认有文件，不显示进度条
                if (oldVal.length == 0 && val.length > 0) {
                    this.show_progress = false;
                }
                // 如果val没有，oldVal也没有，说明是没有或删除了文件，显示进度条 - 进度归零
                if (oldVal.length == 0 && val.length == 0) {
                    this.show_progress = true;
                    this.progress = 0;
                }

            },
            deep: true
        }
    },
    data() {
        return {
            upload_url: this.adminApi.upload_url,
            upload_data: {},
            progress: 0,
            show_progress: true, // 是否显示进度条
        }
    },
    mounted() {
        let that = this;

        this.upload_data = {
            token: this.adminApi.token,
            dir: this.dir
        }
    },
    methods: {
        // 上传进度
        fileProgress(file, fileList) {
            this.progress = Math.round(file.percent)
        },
        // 上传前
        before_upload(e) {
            // 判断上传文件大小
            if (e.size > this.max_size * 1024) {
                this.$message.error('上传文件大小不能超过' + this.max_size + 'kb')
                return false
            }
        },

        // 上传成功
        upload_success(res, file) {
            // console.log('上传成功', res, file)
            if (res) {
                this.$emit('upload_success', res)
            } else {
                this.$message.error(res.msg)
            }
        },
        // 上传失败
        upload_error(err, file, fileList) {

            console.group('上传失败')
            console.log(err, file, fileList)
            console.groupEnd()
            // if (res) {
            //     this.$emit('upload_success', res)
            // } else {
            //     this.$message.error(res.msg)
            // }
        },
        // 批量操作
        batch_ids(val) {
            this.$emit('batch_ids', val)
        }
    }
}
</script>

<style scoped>
.flex-col{
    display: flex;
    flex-direction: column;
}
</style>


// WEBPACK FOOTER //
// src/components/UploadButton.vue